import { useMutation } from 'react-query'
import { postValidateVoucherifyPromoCode } from '../api'

const useValidateVoucherifyPromoCode = () => {
    const { mutateAsync, isLoading, isSuccess } = useMutation(
        postValidateVoucherifyPromoCode
    )

    return { mutateAsync, isLoading, isSuccess }
}

export default useValidateVoucherifyPromoCode
